import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import commaNumber from 'comma-number';
import {convertTimeCreditToPcBangPoint, formatUtcDateToLocalDateFormat} from '../../../../util/timeUtils';
import {fetchProducts} from '../../../../actions/purchase.actions';
import {
  patchUserAutoPayment,
  deleteUserAutoPayment,
  fetchCurrentUserDetailRequest,
} from '../../../../actions/user.actions';
import {PAY_TOOL_NAME} from '../../../../constants/purchase.constants';
import Button from '../../../Common/Button';
import ButtonGroup from '../../../Common/ButtonGroup';
import {PageContainer, PageTitle, Table} from '../../../Common/PageComponents';
import {AutoPaymentPoints} from '../../../Products/Purchase/PurchaseForm';

const stateToProps = state => {
  return {
    user: state.user,
    products: state.purchase.products,
  };
};

class AutoPaymentRequest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      form: false,
      autoPaymentPointInTimeCredit: '',
    };
    this.selectedProductId;
    this.agreeForSmsService;
  }

  _modifyProduct(e) {
    e.preventDefault();

    this.props.dispatch(
      patchUserAutoPayment({
        productId: this.selectedProductId.value,
      })
    );
  }

  _modifyAutoPaymentPointInTimeCredit(e) {
    e.preventDefault();
    this.props.dispatch(
      patchUserAutoPayment({
        autoPaymentPointInTimeCredit:
          this.state.autoPaymentPointInTimeCredit || this.props.user.autoPayment.autoPaymentRemainingTime,
      })
    );
  }

  _modifyAgreeForSmsService(e) {
    e.preventDefault();

    this.props.dispatch(
      patchUserAutoPayment({
        agreeForSmsService: this.agreeForSmsService.value,
      })
    );
  }

  _continueAutoPayment(e) {
    e.preventDefault();
    if (confirm('자동결제를 다시 시작하시겠습니까?')) {
      this.props.dispatch(
        patchUserAutoPayment({
          paused: false,
        })
      );
    }
  }

  _deleteAutoPayment(e) {
    e.preventDefault();
    if (confirm('정말로 자동결제를 해지하시겠습니까?')) {
      this.props.dispatch(deleteUserAutoPayment());
    }
  }

  componentDidMount() {
    this.props.dispatch(fetchProducts());
    this.props.dispatch(fetchCurrentUserDetailRequest());
  }

  _renderOverview() {
    return (
      <div>
        <Table>
          <colgroup>
            <col width="{185}" />
            <col width="{404}" />
            <col width="{159}" />
          </colgroup>
          <thead>
            <tr>
              <th>신청인명</th>
              <th>자동 결제 현황</th>
              <th>작성일</th>
            </tr>
          </thead>
          <tbody>{this.props.user.autoPayment ? this._renderAutoPaymentState() : this._renderNoneAutoPayment()}</tbody>
        </Table>
        {this.props.user.autoPayment ? this._renderAutoPaymentControlButton() : this._renderRequestAutoPaymentButton()}
      </div>
    );
  }

  _renderAutoPaymentState() {
    return (
      <tr>
        <td>{this.props.user.ownerName}</td>
        <td>{this.props.user.autoPayment.paused ? '자동결제 일시정지' : '자동결제 정상'}</td>
        <td>{formatUtcDateToLocalDateFormat(this.props.user.autoPayment.updatedAt)}</td>
      </tr>
    );
  }

  _renderNoneAutoPayment() {
    return (
      <tr>
        <td colSpan={3}>
          <b>자동결제 신청내역이 없습니다.</b>
        </td>
      </tr>
    );
  }

  _renderAutoPaymentControlButton() {
    if (this.props.user.autoPayment.paused) {
      return (
        <div className="centbtn">
          <Button onClick={e => this._continueAutoPayment(e)}>일시정지 해제</Button>
          <Button theme="gray" onClick={e => this._deleteAutoPayment(e)}>
            해지
          </Button>
        </div>
      );
    } else {
      return (
        <ButtonGroup>
          <Button onClick={() => this.setState({form: true})}>변경</Button>
          <Button theme="gray" onClick={e => this._deleteAutoPayment(e)}>
            해지
          </Button>
        </ButtonGroup>
      );
    }
  }

  _renderRequestAutoPaymentButton() {
    return (
      <ButtonGroup>
        <Link to="/products/purchase">
          <Button size="small">자동결제 신청</Button>
        </Link>
      </ButtonGroup>
    );
  }

  handleAutoPaymentPoints = e => {
    this.setState({
      autoPaymentPointInTimeCredit: e.target.value,
    });
  };

  _renderForm() {
    return (
      <div>
        <Table theme={'form'}>
          <tbody>
            <tr>
              <th style={{width: '200px'}}>신청인명</th>
              <td>
                <label>{this.props.user.ownerName}</label>
              </td>
              <th style={{width: '100px'}}>전화번호</th>
              <td>
                <label>{this.props.user.mobile}</label>
              </td>
            </tr>
            <tr>
              <th>이메일</th>
              <td colSpan={3}>
                <label>{this.props.user.email}</label>
              </td>
            </tr>
            <tr>
              <th>결제수단</th>
              <td colSpan={3}>
                <label>{PAY_TOOL_NAME[this.props.user.autoPayment.paymentType]}</label>
              </td>
            </tr>
            <tr>
              <th>결제상품/금액</th>
              <td colSpan={3}>
                {' '}
                {commaNumber(this.props.user.autoPayment.product.price)}원 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <select ref={select => (this.selectedProductId = select)}>
                  <option value={'NONE'}>선택하세요</option>
                  {Object.keys(this.props.products)
                    .sort(
                      (productId1, productId2) =>
                        this.props.products[productId1].price - this.props.products[productId2].price
                    )
                    .map(productId => (
                      <option key={productId} value={productId}>
                        {commaNumber(this.props.products[productId].price)} 원
                      </option>
                    ))}
                </select>
                <Button size="small" onClick={e => this._modifyProduct(e)}>
                  변경
                </Button>
              </td>
            </tr>
            <tr>
              <th>결제시점</th>
              <td colSpan={3}>
                {' '}
                {convertTimeCreditToPcBangPoint(this.props.user.autoPayment.autoPaymentRemainingTime)} 미만 &nbsp;&nbsp;
                <AutoPaymentPoints
                  onChange={this.handleAutoPaymentPoints}
                  defaultValue={this.props.user.autoPayment.autoPaymentRemainingTime}
                />
                <Button size="small" onClick={e => this._modifyAutoPaymentPointInTimeCredit(e)}>
                  변경
                </Button>
              </td>
            </tr>
            <tr>
              <th>
                새벽시간(00:00~07:00)
                <br />
                결제실패 안내 SMS 수신동의
              </th>
              <td colSpan={3}>
                <label style={{marginRight: '5px'}}>
                  <input
                    type="radio"
                    name="agreeForSmsService"
                    value={true}
                    onChange={e => (this.agreeForSmsService = e.target)}
                    defaultChecked={this.props.user.autoPayment.agreeForSmsService}
                  />
                  수신동의
                </label>
                <label style={{marginRight: '5px'}}>
                  <input
                    type="radio"
                    name="agreeForSmsService"
                    value={false}
                    onChange={e => (this.agreeForSmsService = e.target)}
                    defaultChecked={!this.props.user.autoPayment.agreeForSmsService}
                  />
                  수신안함{' '}
                </label>
                <Button size="small" onClick={e => this._modifyAgreeForSmsService(e)}>
                  변경
                </Button>
              </td>
            </tr>
          </tbody>
        </Table>
        <br />
        <div style={{fontSize: 14}}>
          <strong>
            자동결제 재구매 시점 설정 안내
            <br />
            <br />
            자동결제 재구매 시점은 사장님께서 [결제시점]으로 설정하신 잔여포인트가 될 경우
            <br />
            등록되어 있는 신용카드를 통해 이용중이신 상품으로 재구매를 해드리는 서비스 입니다.
            <br />
            본 서비스를 이용하시면 서비스 중단으로 인한 피해를 막을 수 있으며,
            <br />
            서비스의 재구매 및 관리가 편리합니다.
            <br />
            <br />
          </strong>
          ※ 자동 결제 재구매는 잔여포인트가 소진됐을 때 사장님께서 지정해 놓으신 결제 정보에 따라 자동으로 진행되게
          됩니다.
          <br />
          ※ 자동결제 실패 시, 실패 안내 SMS가 전송되며 30분 후 자동결제를 재시도합니다. <br />
          &nbsp;&nbsp;&nbsp;&nbsp;자동결제 2회 실패 시 재시도 시점이 익일로 연기되오니, 실패 안내 SMS 수신 시 자동결제
          수단 점검을 부탁드립니다. <br />
          &nbsp;&nbsp;&nbsp;&nbsp;새벽시간(00:00~07:00)에 SMS 수신을 원하지 않을 경우, 수신안함을 선택해주시기 바랍니다.
          <br />
        </div>
      </div>
    );
  }

  render() {
    return (
      <PageContainer>
        <PageTitle title="자동결제 신청/변경">Home &gt; MY PC방 &gt; PC방 관리 &gt; 자동결제신청/변경</PageTitle>
        {this.state.form ? this._renderForm() : this._renderOverview()}
      </PageContainer>
    );
  }
}

export default connect(stateToProps)(AutoPaymentRequest);
